<template>
  <div v-if="catalog.length" class="catalog-slider">
    <header class="catalog-slider__header">
      <div class="catalog-slider__title-wrap">
        <h3 class="catalog-slider__title">{{ title }}</h3>
        <a v-if="link" :href="link" class="catalog-slider__more">
          {{ $t('see_all') }}
        </a>
      </div>
      <div class="catalog-slider__navigation">
        <div class="swiper-button-prev" :class="[transliterate(title) + '-prev']" slot="button-prev"></div>
        <div class="swiper-button-next" :class="[transliterate(title) + '-next']" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(item, i) in catalog" :key="i">
        <CatalogSliderItem
          :link="item.category_link"
          :thumb="item.category_thumb"
          :name="item.category_name"
          :block-name="titleRu"
          :position="i + 1"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { transliteration } from '../../../mixins/transliteration'
import { isTouch } from '../../../mixins/isTouchDevice'
import CatalogSliderItem from './CatalogSliderItem'

export default {
  name: 'CatalogSlider',
  mixins: [transliteration, isTouch],
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    catalog: {
      type: Array,
      default: () => []
    },
    titleRu: {
      type: String,
      default: ''
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    CatalogSliderItem
  },
  data () {
    return {
      swiperOption: {
        watchSlidesVisibility: true,
        spaceBetween: 10,
        slidesPerView: 1.5,
        navigation: {
          nextEl: '.' + this.transliterate(this.title) + '-next',
          prevEl: '.' + this.transliterate(this.title) + '-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          319: {
            spaceBetween: 10,
            slidesPerView: 2.4
          },
          550: {
            spaceBetween: 10,
            slidesPerView: 3.3
          },
          769: {
            spaceBetween: 20,
            slidesPerView: 4
          },
          1100: {
            spaceBetween: 20,
            slidesPerView: 5
          },
          1300: {
            spaceBetween: 20,
            slidesPerView: 6
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
@import "../../../../node_modules/swiper/css/swiper.min.css"

@import "../../../styles/swiper/swiper"
.catalog-slider
  min-height: 217px
  +mmin($tablet)
    min-height: 273px
.catalog-slider ::v-deep
  .swiper-wrapper
    align-items: flex-start

.catalog-slider__header
  padding: 0 15px

.swiper-container
  padding: 0 15px

.catalog-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.catalog-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.catalog-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0
  min-height: 18px

  +mmin($tablet)
    font-size: 24px
    min-height: 24px

.catalog-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.catalog-slider__navigation
  display: none
  position: relative
  width: 70px

  +mmin($tablet)
    display: block

</style>
